exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-17047ca8] {\n  font-size: 2.5rem;\n}\n#banner_thankyou[data-v-17047ca8] {\n  background-image: url(\"/images/wallpaper_thankyou.png\");\n  height: 455px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: top;\n}", ""]);

// exports
